import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProjectsPage from './pages/ProjectsPage';
import ContactPage from './pages/ContactPage';
import MedusaPage from './pages/MedusaPage';
import ContainPage from './pages/ContainPage';
import ZINKPage from './pages/ZINKPage';
import HomePage from './pages/HomePage';
import NeurofluxPage from './pages/NeurofluxPage';
import OtbbPage from './pages/OtbbPage';
import DashPage from './pages/DashPage';
import TerrainPage from './pages/TerrainPage';
import RazorPage from './pages/RazorPage';
import Medusa_IIPage from './pages/MedusaIIPage';
import ClubcrisisPage from './pages/Clubcrisis';
import OrbitPage from './pages/OrbitPage';
import CreaxPage from './pages/CreaxPage';
import BloomPage from './pages/BloomPage';
import RipplePage from './pages/RipplePage';
import DatadripPage from './pages/DATADRIP';

function App() {
  return (
    <Router>
      <Routes>
        
        <Route path="/" element={<HomePage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/contact" element={<ContactPage />} />

        {/* All Projects  */}
        <Route path="/projects/medusa" element={<MedusaPage />} />
        <Route path="/projects/medusa_ii" element={<Medusa_IIPage />} />
        <Route path="/projects/contain" element={<ContainPage />} />
        <Route path="/projects/neuroflux" element={<NeurofluxPage />} /> 
        <Route path="/projects/otbb" element={<OtbbPage/>}/>
        <Route path="/projects/zink" element={<ZINKPage />} />
        <Route path="/projects/creax" element={<CreaxPage />} />
        <Route path="/projects/---" element={<DashPage />} />
        <Route path="/projects/terrain" element={<TerrainPage />} />
        <Route path="/projects/razor" element={<RazorPage/>} />
        <Route path="/projects/clubcrisis" element={<ClubcrisisPage/>}/>
        <Route path="/projects/orbit" element={<OrbitPage/>}/>
        <Route path="/projects/bloom" element={<BloomPage/>}/>
        <Route path="/projects/ripple" element={<RipplePage/>}/>
        <Route path="/projects/datadrip" element={<DatadripPage/>}/>
  

      </Routes>
    </Router>
  );
}

export default App;
